import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, message, Spin } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface SectorData {
  id: number;
  descripcion: string;
  alta: number;
}

const EditarSectores: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSector = async () => {
      try {
        setIsLoading(true);
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_sectores/${empresa}/${sucursal}/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Error al cargar el insumo');
        }

        const data = await response.json();
        form.setFieldsValue({
          descripcion: data.descripcion,
          alta: data.alta,
        });
      } catch (error) {
        console.error('Error:', error);
        message.error('Error al cargar los datos del sector');
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      fetchSector();
    }
  }, [id, form, getAccessTokenSilently]);

  const onFinish = async (values: any) => {
    setButtonLoading(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_sectores/${empresa}/${sucursal}/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el sector');
      }

      message.success('Sector actualizado correctamente');
      navigate('/listar_sectores');
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al actualizar el sector');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <Spin spinning={isLoading} tip="Cargando datos...">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 600, margin: '20px auto' }}
      >
        <Form.Item
          name="descripcion"
          label="Descripción"
          rules={[{ required: true, message: 'Por favor ingrese la descripción' }]}
        >
          <Input maxLength={30} />
        </Form.Item>

        <Form.Item
          name="alta"
          label="Estado"
          rules={[{ required: true, message: 'Por favor seleccione el estado' }]}
        >
          <Select>
            <Select.Option value={1}>Activo</Select.Option>
            <Select.Option value={0}>Inactivo</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary"
            htmlType="submit" 
            loading={buttonLoading}
            disabled={buttonLoading}
          >
            {buttonLoading ? 'Actualizando...' : 'Actualizar'}
          </Button>
          <Button 
            style={{ marginLeft: 8 }} 
            onClick={() => navigate(`/listar_sectores/${empresa}/${sucursal}`)}
          >
            Listar
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default EditarSectores;